import { lazy } from "react";
import { RoleRoute } from "../../app/router";

const Dashboard           = lazy(() => import("./pages/Dashboard"));
const Users               = lazy(() => import("./pages/Users"));
const Themes              = lazy(() => import("./pages/Themes"));
const Catalogues          = lazy(() => import("./pages/Catalogues"));
const Formations          = lazy(() => import("./pages/Formations"));
const Profile             = lazy(() => import("./pages/Profile"));
const FormationDetail     = lazy(() => import("../../features/formateur/pages/FormationDetail"));
const ModuleDetail        = lazy(() => import("../../features/formateur/pages/ModuleDetail"));
const CatalogueFormations = lazy(() => import("./pages/CatalogueFormations"));

const wrap = (el) => <RoleRoute role="administrateur">{el}</RoleRoute>;

export const adminRoutes = [
  { path: "/admin",                                element: wrap(<Dashboard />) },
  { path: "/admin/users",                          element: wrap(<Users />) },
  { path: "/admin/profile",                        element: wrap(<Profile />) },
  { path: "/admin/themes",                         element: wrap(<Themes />) },
  { path: "/admin/catalogues",                     element: wrap(<Catalogues />) },
  { path: "/admin/formations",                     element: wrap(<Formations />) },
  { path: "/admin/formations/:id",                 element: wrap(<FormationDetail />) },
  { path: "/admin/formations/:id/modules/:moduleId", element: wrap(<ModuleDetail />) },
  { path: "/admin/catalogues/:id/formations",      element: wrap(<CatalogueFormations />) },
];
